import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=0c451cd9&scoped=true"
import script from "./ProjectForm.vue?vue&type=script&lang=js"
export * from "./ProjectForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectForm.vue?vue&type=style&index=0&id=0c451cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c451cd9",
  null
  
)

export default component.exports